import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useChat } from '../../app/ChatContext';
import { useStore } from '../../app/StoreContext';

/** /:slug/chat — the conversation lives in the popup; this route just opens it. */
export function Chat() {
  const { slug } = useStore();
  const chat = useChat();
  useEffect(() => { chat.setOpen(true); }, [chat]);
  return <Navigate to={`/${slug}`} replace />;
}
